import React, { useEffect } from 'react';
import { Card, Form, Input, Button, Row, Col, Divider, message } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined } from '@ant-design/icons';
import { authAPI } from '../api/endpoints';
import { useAuthStore } from '../store';

const ProfilePage = () => {
  const [profileForm] = Form.useForm();
  const [passwordForm] = Form.useForm();
  const user = useAuthStore((state) => state.user);
  const setUser = useAuthStore((state) => state.setUser);
  const [loadingProfile, setLoadingProfile] = React.useState(false);
  const [loadingPassword, setLoadingPassword] = React.useState(false);

  useEffect(() => {
    if (user) {
      profileForm.setFieldsValue({
        username: user.username,
        email: user.email,
        first_name: user.first_name,
        last_name: user.last_name,
      });
    }
  }, [user, profileForm]);

  const handleUpdateProfile = async (values) => {
    setLoadingProfile(true);
    try {
      const { username, ...updateData } = values;
      const response = await authAPI.updateProfile(updateData);
      setUser(response.data);
      message.success('Perfil actualizado correctamente');
    } catch (error) {
      const errors = error.response?.data;
      if (errors) {
        const errorMsg = Object.values(errors).flat().join(', ');
        message.error(errorMsg);
      } else {
        message.error('Error al actualizar el perfil');
      }
    } finally {
      setLoadingProfile(false);
    }
  };

  const handleChangePassword = async (values) => {
    setLoadingPassword(true);
    try {
      await authAPI.changePassword({
        old_password: values.old_password,
        new_password: values.new_password,
      });
      message.success('Contraseña actualizada correctamente');
      passwordForm.resetFields();
    } catch (error) {
      const errors = error.response?.data;
      if (errors) {
        const errorMsg = Object.values(errors).flat().join(', ');
        message.error(errorMsg);
      } else {
        message.error('Error al cambiar la contraseña');
      }
    } finally {
      setLoadingPassword(false);
    }
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <Card title="Información del Perfil">
        <Form
          form={profileForm}
          layout="vertical"
          onFinish={handleUpdateProfile}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="username"
                label="Usuario"
              >
                <Input prefix={<UserOutlined />} disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: 'El email es requerido' },
                  { type: 'email', message: 'Ingresa un email válido' },
                ]}
              >
                <Input prefix={<MailOutlined />} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="first_name" label="Nombre">
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="last_name" label="Apellido">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loadingProfile}>
              Guardar Cambios
            </Button>
          </Form.Item>
        </Form>

        <Divider />

        <h3><LockOutlined /> Cambiar Contraseña</h3>
        <Form
          form={passwordForm}
          layout="vertical"
          onFinish={handleChangePassword}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="old_password"
                label="Contraseña Actual"
                rules={[{ required: true, message: 'Ingresa tu contraseña actual' }]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="new_password"
                label="Nueva Contraseña"
                rules={[
                  { required: true, message: 'Ingresa la nueva contraseña' },
                  { min: 8, message: 'Mínimo 8 caracteres' },
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="confirm_password"
                label="Confirmar Contraseña"
                dependencies={['new_password']}
                rules={[
                  { required: true, message: 'Confirma la nueva contraseña' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('new_password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('Las contraseñas no coinciden'));
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loadingPassword}>
              Cambiar Contraseña
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ProfilePage;
